import React from 'react';

// This is a single skeleton item that mimics your real item's layout.
const SkeletonItem = () => (
  <div className="order-details__item d-flex flex-column flex-sm-row align-items-sm-center justify-content-between p-3 border rounded mb-3 gap-2 gap-sm-3">
    {/* Left Side: Image and Text */}
    <div className="d-flex align-items-center gap-3 flex-grow-1 w-100 w-sm-auto">
      {/* Image Placeholder */}
      <div
        style={{
          flexShrink: 0,
          width: '80px',
          height: '80px',
        }}
        className="skeleton-pulse rounded"
      />

      {/* Text Placeholder */}
      <div className="min-w-0 w-100">
        <div
          style={{ height: '20px' }}
          className="skeleton-pulse rounded w-75 mb-2"
        />
        <div
          style={{ height: '16px' }}
          className="skeleton-pulse rounded w-50"
        />
      </div>
    </div>

    {/* Right Side: Buttons and Price */}
    <div className="d-none d-sm-flex align-items-center gap-3">
      {/* Button Placeholder */}
      <div
        style={{ width: '120px', height: '38px' }}
        className="skeleton-pulse rounded"
      />
      {/* Price Placeholder */}
      <div className="text-end">
        <div
          style={{ height: '20px', width: '60px' }}
          className="skeleton-pulse rounded mb-2 ms-auto"
        />
        <div
          style={{ height: '16px', width: '40px' }}
          className="skeleton-pulse rounded ms-auto"
        />
      </div>
    </div>
  </div>
);

// This component will render multiple skeleton items.
const VerifyProductSkeleton = ({ count = 4 }: { count?: number }) => {
  return (
    <>
      {/* We use a simple CSS animation for the pulse effect. */}
      <style jsx global>{`
        .skeleton-pulse {
          display: inline-block;
          height: 100%;
          width: 100%;
          background: linear-gradient(
            -90deg,
            #f0f0f0 0%,
            #f8f8f8 50%,
            #f0f0f0 100%
          );
          background-size: 400% 400%;
          animation: pulse 1.2s ease-in-out infinite;
        }
        @keyframes pulse {
          0% {
            background-position: 0% 0%;
          }
          100% {
            background-position: -135% 0%;
          }
        }
      `}</style>
      <div className="order-details__items">
        {Array.from({ length: count }).map((_, index) => (
          <SkeletonItem key={index} />
        ))}
      </div>
    </>
  );
};

export default VerifyProductSkeleton;
